import React, { useRef, useState, useEffect } from 'react'
import { useForm } from "react-hook-form";
import Form from "react-validation/build/form";
import ContentLoader from 'react-content-loader';
import { ToastContainer, toast } from 'react-toastify';
import CheckButton from "react-validation/build/button";

import AddExtraFiledService from '../../services/settings/AddExtraFiledServices';
import ButtonLoading from '../../components/Loder/buttonLoading';
import { getTrans as t } from "../../Localization/translations"
import GetCompanyInfoService from '../../services/company/getCompanyInfoService';


function AssetsAddExtraFiled() {

    const checkBtn = useRef();
    const form = useRef();
    const [loading, setLoading] = useState(false)
    const [btnloading, setBtnLoading] = useState(false)
    const { handleSubmit, } = useForm();
    const [asset, setAsset] = useState([
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },
        {
            Attribute1Check: '',
            AttributeLabel: "",
            Attributedatatype: '',
        },

    ]);

    useEffect(() => {
        setLoading(true)
        GetCompanyInfoService.getExtraFiled().then(
            (response) => {
                if (response.data && (response.data.ContractAsset.length >=1)) {
                setAsset([
                    {
                        Attribute1Check: response.data.ContractAsset[0].enable === 'True' ? Boolean(response.data.ContractAsset[0].enable) : response.data.ContractAsset[0].enable,
                        AttributeLabel: response.data.ContractAsset[0].label,
                        Attributedatatype: response.data.ContractAsset[0].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[1].enable === 'True' ? Boolean(response.data.ContractAsset[1].enable) : response.data.ContractAsset[1].enable,
                        AttributeLabel: response.data.ContractAsset[1].label,
                        Attributedatatype: response.data.ContractAsset[1].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[2].enable === 'True' ? Boolean(response.data.ContractAsset[2].enable) : response.data.ContractAsset[2].enable,
                        AttributeLabel: response.data.ContractAsset[2].label,
                        Attributedatatype: response.data.ContractAsset[2].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[3].enable === 'True' ? Boolean(response.data.ContractAsset[3].enable) : response.data.ContractAsset[3].enable,
                        AttributeLabel: response.data.ContractAsset[3].label,
                        Attributedatatype: response.data.ContractAsset[3].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[4].enable === 'True' ? Boolean(response.data.ContractAsset[4].enable) : response.data.ContractAsset[4].enable,
                        AttributeLabel: response.data.ContractAsset[4].label,
                        Attributedatatype: response.data.ContractAsset[4].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[5].enable === 'True' ? Boolean(response.data.ContractAsset[5].enable) : response.data.ContractAsset[5].enable,
                        AttributeLabel: response.data.ContractAsset[5].label,
                        Attributedatatype: response.data.ContractAsset[5].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[6].enable === 'True' ? Boolean(response.data.ContractAsset[6].enable) : response.data.ContractAsset[6].enable,
                        AttributeLabel: response.data.ContractAsset[6].label,
                        Attributedatatype: response.data.ContractAsset[6].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[7].enable === 'True' ? Boolean(response.data.ContractAsset[7].enable) : response.data.ContractAsset[7].enable,
                        AttributeLabel: response.data.ContractAsset[7].label,
                        Attributedatatype: response.data.ContractAsset[7].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[8].enable === 'True' ? Boolean(response.data.ContractAsset[8].enable) : response.data.ContractAsset[8].enable,
                        AttributeLabel: response.data.ContractAsset[8].label,
                        Attributedatatype: response.data.ContractAsset[8].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[9].enable === 'True' ? Boolean(response.data.ContractAsset[9].enable) : response.data.ContractAsset[9].enable,
                        AttributeLabel: response.data.ContractAsset[9].label,
                        Attributedatatype: response.data.ContractAsset[9].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[10].enable === 'True' ? Boolean(response.data.ContractAsset[10].enable) : response.data.ContractAsset[10].enable,
                        AttributeLabel: response.data.ContractAsset[10].label,
                        Attributedatatype: response.data.ContractAsset[10].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[11].enable === 'True' ? Boolean(response.data.ContractAsset[11].enable) : response.data.ContractAsset[11].enable,
                        AttributeLabel: response.data.ContractAsset[11].label,
                        Attributedatatype: response.data.ContractAsset[11].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[12].enable === 'True' ? Boolean(response.data.ContractAsset[12].enable) : response.data.ContractAsset[12].enable,
                        AttributeLabel: response.data.ContractAsset[12].label,
                        Attributedatatype: response.data.ContractAsset[12].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[13].enable === 'True' ? Boolean(response.data.ContractAsset[13].enable) : response.data.ContractAsset[13].enable,
                        AttributeLabel: response.data.ContractAsset[13].label,
                        Attributedatatype: response.data.ContractAsset[13].datatype,
                    },
                    {
                        Attribute1Check: response.data.ContractAsset[14].enable === 'True' ? Boolean(response.data.ContractAsset[14].enable) : response.data.ContractAsset[14].enable,
                        AttributeLabel: response.data.ContractAsset[14].label,
                        Attributedatatype: response.data.ContractAsset[14].datatype,
                    },

                ]
                )
                setLoading(false)  
            }
            else{
                setLoading(false)  

            }
            }
        )
    }, [])

    const [selectform, setSelectForm] = useState("ContractAsset")

    const onChangeAsset = (e, index) => {
        const { name, value, checked, type } = e.target;
        const newVal3 = type === "checkbox" ? checked : value;
        const rowsInputAsset = [...asset]
        rowsInputAsset[index][name] = newVal3
        setAsset(rowsInputAsset)
    }

    const handleRegister = () => {
        setBtnLoading(true)
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
            AddExtraFiledService.addextraFiled(
                selectform,
                asset
            ).then(
                (response) => {
                    if (response.data.success) {
                        toast.success(`${response.data.response}`, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        setBtnLoading(false)
                    }
                    else {
                        toast.error(`${response.data.error}`, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        setBtnLoading(false)
                    }
                },
            )
        }
    }

    return (
        <>
            <ToastContainer />
            {loading !== true ?
                <Form role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addReceiptForm" >
                    {(
                        <>
                            <div className='row'>
                                <div className='col-xl-6'>
                                    <div className='row'>
                                        <div className="col-xl-3 d-none d-xl-block">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label">{t("")}</label>
                                                <div className="col-lg-12">
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 d-none d-xl-block">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label">{t("Enable/Disable")} </label>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 d-none d-xl-block">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label">{t("Label")} </label>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 d-none d-xl-block">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label">{t("DataType")} </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label>
                                                        <input
                                                            type='hidden'
                                                            className='form-control'
                                                            name='AttributeName'
                                                            defaultValue='Atribute 1'
                                                            onChange={(e, index) => onChangeAsset(e, index = 0)}
                                                        />Attribute 1</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    onChange={(e, index) => onChangeAsset(e, index = 0)}
                                                    type="checkbox" value={asset[0].Attribute1Check}
                                                    checked={asset[0].Attribute1Check === true ? true : false}
                                                    name="Attribute1Check" id="Attribute1" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[0].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 0)}
                                                    type="text" name="AttributeLabel" id="Attribute1" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[0].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 0)}
                                                    name='Attributedatatype'
                                                    id="Attribute1" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 2</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    onChange={(e, index) => onChangeAsset(e, index = 1)}
                                                    type="checkbox"
                                                    checked={asset[1].Attribute1Check === true ? true : false}
                                                    value={asset[1].Attribute1Check} id='Attribute2' name="Attribute1Check" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[1].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 1)}
                                                    type="text" name="AttributeLabel" id="Attribute2" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[1].Attributedatatype}
                                                    id='Attribute2'
                                                    name='Attributedatatype'
                                                    onChange={(e, index) => onChangeAsset(e, index = 1)}
                                                    className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 3</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[2].Attribute1Check}
                                                    checked={asset[2].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 2)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[2].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 2)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[2].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 2)}
                                                    id="trade_in_payto" className="form-control form-select"
                                                    name='Attributedatatype'
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 4</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[3].Attribute1Check}
                                                    onChange={(e, index) => onChangeAsset(e, index = 3)}
                                                    type="checkbox"
                                                    checked={asset[3].Attribute1Check === true ? true : false}
                                                    name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[3].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 3)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[3].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 3)}
                                                    id="trade_in_payto" className="form-control form-select"
                                                    name='Attributedatatype'
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none ">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 5</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[4].Attribute1Check}
                                                    checked={asset[4].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 4)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[4].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 4)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[4].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 4)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 6</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[5].Attribute1Check}
                                                    checked={asset[5].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 5)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[5].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 5)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[5].Attributedatatype}
                                                    name='Attributedatatype'
                                                    onChange={(e, index) => onChangeAsset(e, index = 5)}
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 7</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[6].Attribute1Check}
                                                    checked={asset[6].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 6)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[6].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 6)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[6].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 6)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 8</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[7].Attribute1Check}
                                                    checked={asset[7].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 7)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[7].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 7)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[7].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 7)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div className='col-xl-6'>
                                    <div className='row'>
                                        <div className="col-xl-3 d-none d-xl-block ">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label">{t("")}</label>
                                                <div className="col-lg-12">
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 d-none d-xl-block">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label">{t("Enable/Disable")} </label>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 d-none d-xl-block">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label">{t("Label")} </label>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 d-none d-xl-block">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label">{t("DataType")} </label>

                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 9</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[8].Attribute1Check}
                                                    checked={asset[8].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 8)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[8].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 8)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[8].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 8)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label  d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 10</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[9].Attribute1Check}
                                                    checked={asset[9].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 9)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label  d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[9].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 9)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label  d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[9].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 9)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 11</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[10].Attribute1Check}
                                                    checked={asset[10].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 10)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[10].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 10)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[10].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 10)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 12</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[11].Attribute1Check}
                                                    checked={asset[11].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 11)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[11].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 11)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[11].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 11)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 13</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[12].Attribute1Check}
                                                    checked={asset[12].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 12)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[12].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 12)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[12].Attributedatatype}
                                                    onChange={(e, index) => onChangeAsset(e, index = 12)}
                                                    name='Attributedatatype'
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 14</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[13].Attribute1Check}
                                                    checked={asset[13].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 13)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[13].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 13)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[13].Attributedatatype}
                                                    name='Attributedatatype'
                                                    onChange={(e, index) => onChangeAsset(e, index = 13)}
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("")}</label>
                                                <div className="col-lg-12">
                                                    <label
                                                        type="text" name="AttributeLabel" id="trade_in" className="form" >Attribute 15</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Enable/Disable")} </label>
                                                <input
                                                    value={asset[14].Attribute1Check}
                                                    checked={asset[14].Attribute1Check === true ? true : false}
                                                    onChange={(e, index) => onChangeAsset(e, index = 14)}
                                                    type="checkbox" name="Attribute1Check" id="overide_application" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("Label")} </label>
                                                <input
                                                    value={asset[14].AttributeLabel}
                                                    onChange={(e, index) => onChangeAsset(e, index = 14)}
                                                    type="text" name="AttributeLabel" id="trade_in" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="col-lg-12">
                                                <label className="col-lg-12 col-form-label d-block d-xl-none">{t("DataType")} </label>
                                                <select
                                                    value={asset[14].Attributedatatype}
                                                    name='Attributedatatype'
                                                    onChange={(e, index) => onChangeAsset(e, index = 14)}
                                                    id="trade_in_payto" className="form-control form-select">
                                                    <option value="">{t("Select")}</option>
                                                    <option value="text">{t("String")}</option>
                                                    <option value="number">{t("Number")}</option>
                                                    <option value="date">{t("Date")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md mt-2">
                                {btnloading === false ? (
                                    t('Save')
                                ) : (
                                    <ButtonLoading />
                                )
                                } </button>
                        </>

                    )
                    }
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form> :
                <ContentLoader
                    viewBox="0 0 1200 450"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                >
                    <rect x="24" y="50" rx="4" ry="4" width="20" height="19"></rect>
                    <rect x="67" y="50" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="188" y="50" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="402" y="50" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="523" y="50" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="731" y="50" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="852" y="50" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="26" y="100" rx="4" ry="4" width="20" height="20"></rect>
                    <rect x="66" y="100" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="187" y="100" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="401" y="100" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="522" y="100" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="730" y="100" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="851" y="100" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="26" y="150" rx="4" ry="4" width="20" height="20"></rect>
                    <rect x="66" y="150" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="187" y="150" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="401" y="150" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="522" y="150" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="730" y="150" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="851" y="150" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="26" y="200" rx="4" ry="4" width="20" height="20"></rect>
                    <rect x="66" y="200" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="187" y="200" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="401" y="200" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="522" y="200" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="730" y="200" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="851" y="200" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="26" y="250" rx="4" ry="4" width="20" height="20"></rect>
                    <rect x="66" y="250" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="187" y="250" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="401" y="250" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="522" y="250" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="730" y="250" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="851" y="250" rx="10" ry="10" width="85" height="19"></rect>
                    <rect x="978" y="50" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="977" y="100" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="977" y="150" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="977" y="200" rx="10" ry="10" width="169" height="19"></rect>
                    <rect x="977" y="250" rx="10" ry="10" width="169" height="19"></rect>

                </ContentLoader>
            }
        </>
    )
}

export default AssetsAddExtraFiled
